import { render, staticRenderFns } from "./choseGtMaterial.vue?vue&type=template&id=0d46c31e&scoped=true&"
import script from "./choseGtMaterial.vue?vue&type=script&lang=js&"
export * from "./choseGtMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d46c31e",
  null
  
)

export default component.exports